<template>
  <div class="vue-ueditor-box">
    <vue-ueditor-wrap
      refs="ueditor"
      v-model="editorContent"
      :config="myConfig"
      @ready="handleReady"
    ></vue-ueditor-wrap>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    VueUeditorWrap,
  },
  props: {
    editorChildContent: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editorContent: "",
      editor: null,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口
        serverUrl: "/com/com/file/ueditorFileUpload",
        imageActionName: "uploadimage" /* 执行上传图片的action名称 */,
        imageFieldName: "file" /* 提交的图片表单名称 */,
        imageAllowFiles: [".png", ".jpg", ".jpeg", ".gif", ".bmp"],
        imagePathFormat:
          "/com/com/file/ueditorFileUpload?filePath=/{yyyy}{mm}{dd}/{filename}", //回显图片
        imageUrlPrefix: "", //图片前缀

        /* 上传文件配置 */
        fileActionName:
          "uploadfile" /* controller里,执行上传视频的action名称 */,
        fileFieldName: "file" /* 提交的文件表单名称 */,
        filePathFormat:
          "/com/com/file/ueditorFileUpload?filePath=/{yyyy}{mm}{dd}/{filename}" /* 上传保存路径,可以自定义保存路径和文件名格式 */,
        fileUrlPrefix: "" /* 文件访问路径前缀 */,
        fileAllowFiles: [
          ".png",
          ".jpg",
          ".jpeg",
          ".gif",
          ".bmp",
          ".flv",
          ".swf",
          ".mkv",
          ".avi",
          ".rm",
          ".rmvb",
          ".mpeg",
          ".mpg",
          ".ogg",
          ".ogv",
          ".mov",
          ".wmv",
          ".mp4",
          ".webm",
          ".mp3",
          ".wav",
          ".mid",
          ".rar",
          ".zip",
          ".tar",
          ".gz",
          ".7z",
          ".bz2",
          ".cab",
          ".iso",
          ".doc",
          ".docx",
          ".xls",
          ".xlsx",
          ".ppt",
          ".pptx",
          ".pdf",
          ".txt",
          ".md",
          ".xml",
        ] /* 上传文件格式显示 */,
        UEDITOR_HOME_URL: "/static/UEditor/", //一定要注意此处！！！！
      },
    };
  },
  watch: {
    editorContent(val) {
      this.$emit("getContent", val);
    },
  },
  methods: {
    handleReady() {},
    getUEContent() {
      return this.editorContent;
    },
    setText(val) {
      this.editorContent = val;
    },
  },
  mounted() {
    // this.editor = UE.getEditor(this.$refs["ueditor"]);
    this.editorContent = this.editorChildContent || "";
  },
  // destroyed() {
  //   // 将editor进行销毁
  //   this.editor.destroy();
  // },
};
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Ueditor/index.vue